export enum AuditLogEntityTypeEnum {
	ACCOUNTING_TRANSACTION = 'ACCOUNTING_TRANSACTION'
}

export enum AuditLogActionEnum {
	CREATE = 'CREATE',
	UPDATE = 'UPDATE',
	DELETE = 'DELETE'
}
